/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".divider[_ngcontent-%COMP%]{border-bottom:1px solid #f0f0f0}.locked-box[_ngcontent-%COMP%]{background-color:#f4f4f4;border-radius:8px}@media screen and (min-width:526px){[_nghost-%COMP%]   .state-text[_ngcontent-%COMP%]{font-size:1.25rem}}"];
export { styles as styles };
//# sourceMappingURL=group-class-state.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state.scss.shim.ngstyle.js
// module id = 420
// module chunks = 27 28 29